import { histogramDygraphConfiguration } from './histogramDygraphConfiguration.js';
import { dyGraphConfigurationGenerator } from './dyGraphConfigurationGenerator.js';

angular
    .module('signalview.dyGraphConfig', [])
    .constant('histogramDygraphConfiguration', histogramDygraphConfiguration)
    .service('dyGraphConfigurationGenerator', dyGraphConfigurationGenerator);
